import * as React from "react";
import {Component} from "react";
import styles from "../../styles/flyouts/room_types/RoomTypesFlyout.scss";
import * as _ from "lodash";
import CloseBigIcon from "../../assets/images/close-big-15x15.svg";
import {__, setTableParams} from "../../core/utils";
import {subscribe} from "react-contextual/dist/react-contextual.es";
import Localization from "../../helpers/Localization";
import {setNotification} from "../../redux/actions/general/notification";
import withRouter from "react-router/es/withRouter";
import Tooltip from "../../components/Tooltip";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import {hideAlertbox, showAlertbox} from "../../redux/actions/general/alertbox";
import classNames from "classnames";
import Properties from "./Properties";
import {deleteRoomTypes, listRoomTypes} from "../../redux/actions/table/room_types";

@subscribe(Localization, "localization")
@withRouter
class RoomTypesFlyout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active: 'properties'
        }
    }

    render() {
        const {data, readAction} = this.props;

        return (
            <div className={styles.preview}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        <span>
                            {_.get(data.title, _.findKey(_.get(data, 'project_languages'), primary => primary == 1))}
                        </span>
                        <CloseBigIcon onClick={() => setTimeout(() => {
                            setTableParams('room_types', {
                            clicked_row: undefined
                        })}, 100)}/>
                    </div>
                    <div className={styles.actions}>
                        <div className={styles.actionWrapper}>
                            <Tooltip text={__('room-types.tooltip.delete-room-type')} key={_.uniqueId()}>
                                <DeleteIcon
                                    onClick={e => {
                                        e.stopPropagation();

                                        showAlertbox({
                                            color: "red",
                                            title: __('general.alert.are-you-sure'),
                                            description: __('room-types.alert.delete-confirmation'),
                                            buttons: [
                                                {
                                                    color: 'lightGray',
                                                    text: __('general.alert.no-close'),
                                                    onClick: 'close'
                                                },
                                                {
                                                    color: 'gray',
                                                    text: __('general.alert.yes-delete'),
                                                    onClick: () => {
                                                        deleteRoomTypes([data.id]).then(() => {
                                                            hideAlertbox();

                                                            setNotification(__('room-types.alert.deleted'));
                                                            listRoomTypes(this.props.match.params.stage);

                                                            setTableParams('room_types', {
                                                                clicked_row: undefined
                                                            });
                                                        });
                                                    },
                                                }
                                            ]
                                        })
                                    }}
                                />
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className={styles.tabs}>
                    <span className={classNames(this.state.active == 'properties' && styles.active)} onClick={() => this.setState({active: 'properties'})}>{__('room-types.flyout.properties')}</span>
                </div>
                {!_.isEmpty(data) && this.state.active == 'properties' && <Properties data={data} readAction={readAction} />}
            </div>
        );
    }
}

export default RoomTypesFlyout;
